import { useState } from 'react';
import { Box, Button, useTheme, styled } from '@mui/material';
import { get } from 'lodash';
import { getLinkForParselToSetInWallet } from '../../helpers';
import { STRINGS, FORM, ENV } from '../../constants';

const StyledButton = styled(Button)(({ theme, isActive }) => ({
  ...(isActive && {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
  }),
  '&:hover, &focus': {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
  },
}));

const WalletButton = ({ platform, shipmentId, parcelId }) => {
  const theme = useTheme();
  const isApple = platform === 'apple';
  const isGoogle = platform === 'google';

  if (!isApple && !isGoogle) return null;

  return (
    <Button
      href={getLinkForParselToSetInWallet(platform, shipmentId, parcelId)}
      rel='noopener noreferrer'
      sx={{
        mb: isApple ? 2 : 0,
        width: '100%',
        background: theme.palette.primary.black,
        color: theme.palette.primary.contrastText,
        '&:hover': {
          background: theme.palette.primary.black,
          color: theme.palette.primary.contrastText,
        },
      }}
      variant='outlined'
    >
      <img
        style={{ marginRight: 8 }}
        src={`${ENV.CDN_BASE_URL_IMAGES}/${
          isApple ? 'applePayIcon.png' : 'googlePayIcon.png'
        }`}
        alt={isApple ? 'Apple Pay' : 'Google Pay'}
      />
      {isApple ? STRINGS.ADD_TO_WALLET.APPLE : STRINGS.ADD_TO_WALLET.GOOGLE}
    </Button>
  );
};

const SingleParcel = ({ barcodes, shipmentId, shipment, isSmallScreen }) => {
  const theme = useTheme();
  const [selectedBarcodeIndex, setSelectedBarcodeIndex] = useState(0);

  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  const isAndroid = /android/i.test(userAgent);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          mb: 2,
        }}
      >
        <Box
          sx={{
            border: `1px solid ${theme.palette.primary.borderLight} `,
            padding: 1,
            borderRadius: '4px',
          }}
        >
          <img
            src={`data:image/png;base64, ${barcodes[selectedBarcodeIndex].barcodeImage.imageData}`}
            alt={`parcel ${selectedBarcodeIndex} QR Code`}
            style={{ maxWidth: '100%', height: 'auto' }}
          />
        </Box>
      </Box>

      {barcodes.length > 1 && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            gap: 2,
            paddingX: 2,
          }}
        >
          {barcodes.map((barcode, index) => (
            <StyledButton
              key={index}
              sx={{ flex: 1 }}
              variant='outlined'
              onClick={() => setSelectedBarcodeIndex(index)}
              isActive={selectedBarcodeIndex === index}
            >
              {index + 1}
            </StyledButton>
          ))}
        </Box>
      )}
      {isSmallScreen && (
        <Box
          sx={{
            px: 2,
            mt: 2,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {isIOS && (
            <WalletButton
              platform='apple'
              shipmentId={shipmentId}
              parcelId={get(
                shipment,
                `${FORM.SHIPMENT_FIELDS.PARCELS.KEY}[${selectedBarcodeIndex}].parcelId`
              )}
            />
          )}
          {isAndroid && (
            <WalletButton
              platform='google'
              shipmentId={shipmentId}
              parcelId={get(
                shipment,
                `${FORM.SHIPMENT_FIELDS.PARCELS.KEY}[${selectedBarcodeIndex}].parcelId`
              )}
            />
          )}
        </Box>
      )}
    </>
  );
};

export default SingleParcel;
